const ServerURL = process.env.REACT_APP_SERVER_URL

export const AppraisalsPathURL = ServerURL+"/appraisals"
export const AppraisersPathURL = ServerURL+"/appraisers"

export const ManageProfileURL = process.env.REACT_APP_SSO_AUTHORITY_URL+"/Identity/Account/Manage"